import { Controller } from "stimulus"

export default class extends Controller {
   static targets = ["modal"]

   open(){
      this.modalTarget.style.display="block"
      var backdrop = document.createElement('div');
      backdrop.id = "bs.backdrop";
      backdrop.classList.add("modal-backdrop")
      document.body.appendChild(backdrop);
   }

   close(){
      this.modalTarget.style.display="none"
      var backdrop = document.getElementById("bs.backdrop")
      backdrop.remove()
   }
}
